<template>
  <div class="container-main" v-if="!isLoading">
    <div class="d-flex justify-space-between">
      <div class="container-main-header-button">
        <v-btn depressed @click="back">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span>Редактирование</span>
      </div>
      <div></div>
    </div>

    <div class="container-block">
      <div class="d-flex">
        <v-textarea
          label="Основной текст"
          required
          type="text"
          outlined
          v-model="documents.text"
          rows="1"
          auto-grow
          no-resize
        ></v-textarea>
      </div>
    </div>

    <div class="container-block">
      <div class="container-block-title">
        {{ files.length > 1 ? "Вложенные файлы" : "Вложенный файл" }}
      </div>

      <div
        class="d-flex justify-space-between"
        v-for="item in files"
        :key="item.id"
      >
        <div style="width: 47%">
          <v-text-field
            label="Название"
            required
            type="text"
            outlined
            v-model="item.name"
          ></v-text-field>
        </div>
        <div
          class="container-block-file-preview"
          v-if="typeof item.url == 'string'"
        >
          <v-icon> mdi-file-pdf-box </v-icon>
          <a style="margin-left: 8px" target="_blank" :href="item.url">{{
            item.name
          }}</a>
          <v-icon
            color="var(--app-red-1)"
            style="margin-left: 8px"
            @click="deleteFile(item)"
          >
            mdi-delete-outline
          </v-icon>
        </div>
        <div style="width: 47%" v-else>
          <v-file-input
            outlined
            v-model="item.url"
            label="Прикрепите файл pdf"
            :rules="[
              (value) =>
                (value && value.size < 104857600) || 'Весом до 100 мб.',
            ]"
            accept="application/pdf,application/vnd.ms-excel"
          ></v-file-input>
        </div>
      </div>

      <div class="container-block-gallery-button" v-if="files.length < 5">
        <span @click="addFile">Добавить файл</span>
      </div>
    </div>

    <ImageCropper
      @imageDesktopBlob="
        (img) => {
          photo.image = img;
        }
      "
      @imageMobileBlob="
        (img) => {
          photo.imageMobile = img;
        }
      "
      @imageTabletBlob="
        (img) => {
          photo.imageTablet = img;
        }
      "
      :width="'100%'"
      :modelValue="newImage"
      :imgSrcProp="documents.image"
      :imgSrcMobileProp="documents.imageMobile"
      :imgSrcTabletProp="documents.imageTablet"
      :placeToDisplay="'Изображение на фоне раздела'"
      :format="'Иконка раздела'"
      hideTitle
    ></ImageCropper>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn
          @click="saveDocuments"
          style="width: auto !important"
          class="button-accept"
        >
          Сохранить
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import ImageCropper from "../../../../components/inputs/ImageCropper.vue";
export default {
  components: {
    ImageCropper,
  },
  data: () => ({
    activity: {},

    errImages: false,
    errImagesMain: false,

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    documents: {},
    files: [],

    isLoading: true,

    photo: {
      image: null,
      imageMobile: null,
      imageTablet: null,
    },

    smartphoneMainImage: null,
    tabletMainImage: null,
    formData: new FormData(),
  }),

  methods: {
    deleteItem(item) {
      const newArr = this.files.filter((i) => i.file != item.file);
      this.files = newArr;
    },
    addFile() {
      const newObj = {
        name: "",
        file: null,
      };
      this.files.push(newObj);
    },

    back() {
      this.$emit("goToDetail");
    },

    async getDocuments() {
      const { data } = await this.$axios.get(
        `${this.$store.getters.apiAdminPanelV5}/ksa-election-blocks/election-documents`,
        {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        }
      );

      this.documents = data.documents;
      this.photo = {
        image: data.documents.image,
        imageMobile: data.documents.imageMobile,
        imageTablet: data.documents.imageTablet,
      };
      this.files = data.files;
      this.isLoading = false;
    },
    deleteFile(item) {
      this.files = this.files.filter((i) => i.id != item.id);
    },
    async uploadMultipleImages() {
      const { data } = await this.$axios.post(
        this.$store.getters.apiAdminPanelV5 + "/upload/multiple",
        this.formData,
        {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        }
      );
      this.formData = new FormData();
      return data;
    },
    async saveDocuments() {
      const filesToAppend = [
        { key: "image", file: this.photo.image },
        { key: "imageMobile", file: this.photo.imageMobile },
        { key: "imageTablet", file: this.photo.imageTablet },
      ];
      this.files.forEach((file, index) => {
        filesToAppend.push({ key: `files-${index}`, file: file.url });
      });

      let hasError = false;
      filesToAppend.forEach(({ key, file }) => {
        if (!file) {
          hasError = true;
        } else if (file instanceof File || file instanceof Blob) {
          this.formData.append(key, file);
        }
      });
      if (hasError) return;

      const uploadedFiles = await this.uploadMultipleImages();
      const filesObject = uploadedFiles.reduce(
        (acc, { fieldname, ...rest }) => {
          acc[fieldname] = rest;
          return acc;
        },
        {}
      );
      const documentsBody = {
        showBlock: this.documents.showBlock,
        text: this.documents.text,
        image: filesObject.image?.url ?? this.documents.image,
        imageMobile: filesObject.imageMobile?.url ?? this.documents.imageMobile,
        imageTablet: filesObject.imageTablet?.url ?? this.documents.imageTablet,
        files: this.files.map((file, index) => ({
          name: file.name,
          size: file.url?.size,
          url: filesObject[`files-${index}`]?.url ?? "url",
          type: "document",
        })),
      };

      try {
        await this.$axios
          .post(
            this.$store.getters.apiAdminPanelV5 +
              "/ksa-election-blocks/election-documents",
            documentsBody,
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
                "secret-key": this.$store.state.secretKeyCookie,
              },
            }
          )
          .then(() => {
            this.$store.commit("errorSet", {
              key: true,
              text: "Данные успешно сохранены",
              type: "success",
            });
          });
      } catch (err) {
        this.$store.commit("errorSet", true);
        this.$store.commit("errorTextSet", err);
      }
    },
  },
  created() {
    this.getDocuments();
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.switch-label {
  font-size: 16px;

  margin-bottom: 2px;
}

.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }

    .container-main-checkbox {
      border: 1px solid rgba(0, 0, 0, 0.42);
      border-radius: 4px;
      padding-top: 20px;
      padding-left: 12px;
      margin-top: 0px !important;
    }

    .container-block-file-preview {
      width: 47%;
      height: 56px;
      display: flex;
      align-items: center;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
